import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	errorMessage: {
		'id': 'typeDimensions.errorMessage',
		'defaultMessage': 'Min side 20cm',
	},
});


// WEBPACK FOOTER //
// ./src/components/AnswerTypeDimensions/messages.js